import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="alert"
export default class extends Controller {
  dismiss() {
    this.element.setAttribute("data-alert-dismissing", "")

    this.element.addEventListener("transitionend", () => {
      this.element.remove()
    }, { once: true })
  }
}
